export class PortalAuthError extends Error {
  public readonly code: string = 'portal-auth-error';
}

export class NotImplementedError extends PortalAuthError {
  public override readonly code: string = 'not-implemented-error';

  constructor(message?: string) {
    super(message ?? 'Not yet implemented');
  }
}

export class PortalApiConfigurationMissingError extends PortalAuthError {
  public override readonly code: string =
    'portal-api-configuration-missing-error';

  constructor(message?: string) {
    super(message ?? 'Portal-API connection is not configured');
  }
}

/**
 * Exception to indicate that a password was not fulfilling the password
 * policies for password change requests.
 */
export class WrongPasswordFormatError extends Error {}
